var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSellpoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 1.5A8.36 8.36 0 000 9.95c0 5.84 7.4 13.5 7.71 13.82a.75.75 0 001.08 0c.31-.32 7.71-7.98 7.71-13.82 0-4.66-3.7-8.45-8.25-8.45zm0 12a3.76 3.76 0 11.01-7.51 3.76 3.76 0 01-.01 7.51z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 0c-1.28 0-2.5.31-3.58.85a9.86 9.86 0 014.27 3.72 3.75 3.75 0 011.44 6.76c-.47 3.16-2.44 6.5-4.33 9.08.9 1.07 1.57 1.77 1.66 1.86a.75.75 0 001.08 0C16.6 21.95 24 14.3 24 8.45 24 3.79 20.3 0 15.75 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSellpoints);
export default ForwardRef;